/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

/* eslint-disable import/prefer-default-export */

import { DashboardWidget } from 'features/widget/types'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { hasInternalAnalysisPermission } from '../../../../utils/permissionUtil'

export const getProvisionedInsightDataSet = (
  widgetData: DashboardWidget<InsightCount>,
  pageConfigUser: any
): InsightData[] => {
  const entries = widgetData!.data![0]!.results![0]!.data!.insights![0]!.dataset![0]!.set ?? []
  return entries.filter(
    (entry) =>
      hasInternalAnalysisPermission(pageConfigUser.userPermissions) || entry.name !== 'Internal'
  )
}
